"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalServerError = void 0;
const BaseError_1 = require("./BaseError");
class InternalServerError extends BaseError_1.BaseError {
    constructor(description = "Internal Server Error") {
        super("InternalServerError", 500, description, true);
    }
}
exports.InternalServerError = InternalServerError;
